import queryString from "query-string";
import { StripeMicroServiceAxiosInstance } from "@/config/AxiosInstance";

type RequestPayload = Record<string, unknown>;
type QueryPayload = Record<string, unknown>;
type SessionId = string | number;

export const stripeMicroService = {
  subscriptionPayment,
  subscriptionPaymentConfirm,
  canadaSubscriptionPaymentConfirm,
  cadSubscriptionPaymentConfirm,
  padSubscriptionPaymentConfirm,
  pendingInvoiceCheck,
  openCustomerPortal,
  getInvoiceHistory,
  getPaymentsLedger,
  getCurrentSubscriptions,
  getSubscriptionHistory,
  joinCampaignPayment,
  joinCampaignPaymentConfirm,
  boostCampaignPayment,
  boostCampaignPaymentConfirm,
  extendCampaignPayment,
  extendCampaignPaymentConfirm,
};

function subscriptionPayment(data: RequestPayload) {
  return StripeMicroServiceAxiosInstance.post(`/subscription/create`, data);
}

function subscriptionPaymentConfirm(session_id: SessionId) {
  return StripeMicroServiceAxiosInstance.get(
    `/subscription/return?session_id=${session_id}&request_from=1`
  );
}

function canadaSubscriptionPaymentConfirm(session_id: SessionId) {
  return StripeMicroServiceAxiosInstance.get(
    `/canada-subscription/return?session_id=${session_id}&request_from=1`
  );
}

function cadSubscriptionPaymentConfirm(session_id: SessionId) {
  return StripeMicroServiceAxiosInstance.get(
    `/cad-subscription/return?session_id=${session_id}&request_from=1`
  );
}

function padSubscriptionPaymentConfirm(session_id: SessionId) {
  return StripeMicroServiceAxiosInstance.get(
    `/pad-subscription/return?session_id=${session_id}&request_from=1`
  );
}

function pendingInvoiceCheck(data: RequestPayload) {
  return StripeMicroServiceAxiosInstance.post(
    `/subscription/pending-invoice-check`,
    data
  );
}

function openCustomerPortal(data: RequestPayload) {
  return StripeMicroServiceAxiosInstance.post(`/customer/portal`, data);
}

function getInvoiceHistory(data: QueryPayload) {
  const query = queryString.stringify(data);
  return StripeMicroServiceAxiosInstance.get(`/invoice/list?${query}`);
}

function getPaymentsLedger(data: QueryPayload) {
  const query = queryString.stringify(data);
  return StripeMicroServiceAxiosInstance.get(`/payments/ledger?${query}`);
}

function getCurrentSubscriptions(data: QueryPayload) {
  const query = queryString.stringify(data);
  return StripeMicroServiceAxiosInstance.get(
    `/subscription/current-list?${query}`
  );
}

function getSubscriptionHistory(data: QueryPayload) {
  const query = queryString.stringify(data);
  return StripeMicroServiceAxiosInstance.get(`/subscription/history?${query}`);
}

function joinCampaignPayment(data: RequestPayload) {
  return StripeMicroServiceAxiosInstance.post(`/campaign/participant`, data);
}

function joinCampaignPaymentConfirm(session_id: SessionId) {
  return StripeMicroServiceAxiosInstance.get(
    `/campaign/participant/return?session_id=${session_id}`
  );
}

function boostCampaignPayment(data: RequestPayload) {
  return StripeMicroServiceAxiosInstance.post(
    `/boost-campaign/participant`,
    data
  );
}

function boostCampaignPaymentConfirm(session_id: SessionId) {
  return StripeMicroServiceAxiosInstance.get(
    `/boost-campaign/participant/return?session_id=${session_id}`
  );
}

function extendCampaignPayment(data: RequestPayload) {
  return StripeMicroServiceAxiosInstance.post(
    `/extend-campaign/participant`,
    data
  );
}

function extendCampaignPaymentConfirm(session_id: SessionId) {
  return StripeMicroServiceAxiosInstance.get(
    `/extend-campaign/participant/return?session_id=${session_id}`
  );
}
